import { useTenantContext } from 'shared/contexts';
import { FeatureFlagKey } from 'shared/types';

/**
 * Per-tenant feature flag check. Flags come from the signed-in tenant's config,
 * so each tenant can have a feature on or off independently.
 */
export default function useFeatureEnabled(flag: FeatureFlagKey): boolean {
    const tenant = useTenantContext();

    return Boolean(tenant?.featuresEnabled?.[flag]);
}
